import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

import { Item } from '~/types/data-array'
import { cx } from '~/utils'

import * as containerStyles from './FormInfo.module.scss'

interface FormInfoProps {
  image: IGatsbyImageData | JSX.Element | undefined
  alt?: string
  title: string
  isHRInfo?: boolean
  isSalesInfo?: boolean
  salesInfoText?: Item[]
  formInfoClassName?: string
}

const FormInfo = ({
  image,
  alt,
  title,
  isHRInfo,
  isSalesInfo,
  salesInfoText,
  formInfoClassName,
}: FormInfoProps) => (
  <div
    className={cx(
      containerStyles.formInfo,
      containerStyles[`${formInfoClassName}`],
    )}
  >
    <div className={containerStyles.formInfo__image}>
      {React.isValidElement(image) ? (
        image
      ) : (
        <GatsbyImage
          image={image as IGatsbyImageData}
          alt={`${alt} | Codica`}
          title={alt}
          loading="lazy"
        />
      )}
    </div>

    {isSalesInfo && (
      <>
        <div className={containerStyles.formInfo__title}>{title}</div>
        <ul className={containerStyles.formInfo__list}>
          {salesInfoText?.map(({ item }, index) => <li key={index}>{item}</li>)}
        </ul>
      </>
    )}

    {isHRInfo && (
      <div className={containerStyles.formInfo__sectionHr}>
        <div>
          <div className={containerStyles.formInfo__title}>{title}</div>
          <a
            href="tel:+380509856205"
            className={containerStyles.formInfo__link}
          >
            +380 50 218 45 43
          </a>
          <a
            href="mailto:hello@codica.com"
            className={containerStyles.formInfo__link}
          >
            hello@codica.com
          </a>
        </div>
      </div>
    )}
  </div>
)

export default FormInfo
